import { RELATIONSHIP_TYPES } from '../../../constants/common/relationShipTypes';

export interface IEnrolleeDetails {
    "name": string,
    "startDate": string,
    "endDate": string,
    "relationship": keyof typeof RELATIONSHIP_TYPES,
    "exchgIndivIdentifier": string,
    checked?: boolean,
    disable?: boolean
}

export const ENROLLMENT_PLAN_STATUS = {
    PENDING: {
        value: 'PENDING',
        key: 'pending'
    },
    PEND: {
        value: 'PEND',
        key: 'pend'
    },
    CANCELLED: {
        value: 'CANCELLED',
        key: 'cancelled'
    },
    PEND_CANCELED: {
        value: 'PEND CANCELED',
        key: 'Pend_Canceled'
    },
    TERMINATED: {
        value: 'TERMINATED',
        key: 'terminated'
    },
    ENROLLED: {
        value: 'ENROLLED',
        key: 'enrolled'
    },
    ABORTED: {
        value: 'ABORTED',
        key: 'aborted'
    }
};

export interface IEnrollmentDetails {
    "enrollmentId": string,
    "policyId": string | null,
    "coverageStartDate": string,
    "coverageEndDate": string,
    "enrollmentStatus": string,
    "monthlypremium": string,
    "netPremium": string,
    "electedAptc": string,
    "electedStateSubsidy": string,
    "productType": string,
    "csrLevel": string,
    "premiumEffDate": string,
    "planLogoUrl": string,
    "planName": string,
    "planId": string,
    "officeVisit": string,
    "genericMedications": string,
    "deductible": string,
    "oopMax": string,
    "paymentUrl": string,
    "issuerPhone": string,
    "issuerSite": string,
    "enrolleeHistoryEntries": IEnrolleeDetails[],
    "allowDisenroll": boolean,
    "allowPaymentRedirect": boolean,
    "benefitDetailsUrl": string,
    "creationTimestamp": number,
    "caseNumber": string,
    "isPlanEffectuated": "Y" | "N",
    "endOfCurrentMonth": string | null,
    "endOfNextMonth": string | null,
    "endOfMonthAfterNext": string | null,
    "planType": string,
    "terminationDateChangeAllowed": boolean,
    "allowEnrollStatusUpdate": boolean,
    "insideOEEnrollmentWindow": boolean,
    "routineDental": string | null,
    "dentalCheckup": string | null,
    "statePremiumCreditAmt": string,
}
